import React from "react";
import { Layout, Menu, Typography, Grid, FloatButton } from "antd"; // 1. Thêm FloatButton
import { BookFilled, WechatFilled, HeartFilled } from "@ant-design/icons";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();

  // Logic: Nếu màn hình nhỏ hơn md (768px) thì là mobile
  const isMobile = !screens.md;

  const items = [
    {
      key: "/",
      icon: <BookFilled style={{ fontSize: "1.2rem" }} />,
      label: "Từ Vựng",
    },
    {
      key: "/hoi-thoai",
      icon: <WechatFilled style={{ fontSize: "1.2rem" }} />,
      label: "Hội Thoại",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: "#fcf9f4" }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        width={260}
        theme="light"
        style={{
          boxShadow: "4px 0 20px rgba(0,0,0,0.02)",
          background: "#ffffff",
          borderRight: "none",
          zIndex: 100,
          height: "100vh",
          position: isMobile ? "fixed" : "sticky",
          top: 0,
          left: 0,
        }}
        zeroWidthTriggerStyle={{
          top: 12,
          background: "#FF7E67",
          color: "#fff",
          borderRadius: "0 4px 4px 0",
        }}
      >
        <div style={{ padding: "32px 24px", textAlign: "center" }}>
          {/* Logo Cozy */}
          <div
            style={{
              width: 56,
              height: 56,
              background: "linear-gradient(135deg, #FF9A8B 0%, #FF6A88 100%)",
              borderRadius: "50%",
              margin: "0 auto 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 8px 16px rgba(255, 106, 136, 0.3)",
              color: "white",
              fontSize: 28,
              fontWeight: 800,
            }}
          >
            <span style={{ fontFamily: "Kanit" }}>th</span>
          </div>
          <Title
            level={3}
            style={{ color: "#4a4a4a", margin: 0, fontFamily: "Kanit" }}
          >
            Thai<span style={{ color: "#FF6A88" }}>Learn</span>
          </Title>
          <div
            style={{
              marginTop: 8,
              color: "#999",
              fontSize: 14,
              fontFamily: "Kanit",
            }}
          >
            Học vui mỗi ngày <HeartFilled style={{ color: "#FF6A88" }} />
          </div>
        </div>

        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items}
          onClick={(e) => navigate(e.key)}
          style={{
            borderRight: 0,
            padding: "0 16px",
            fontFamily: "Kanit",
            fontSize: "16px",
            fontWeight: 500,
          }}
        />
      </Sider>

      <Layout
        style={{
          background: "#fcf9f4",
          marginLeft: isMobile ? 0 : 0,
        }}
      >
        <Header
          style={{
            padding: isMobile ? "0 16px" : "0 40px",
            background: "transparent",
            height: "auto",
            minHeight: 90,
            display: "flex",
            alignItems: "center",
            marginTop: isMobile ? 10 : 20,
            marginBottom: isMobile ? 10 : 0,
          }}
        >
          <div style={{ marginLeft: isMobile ? 32 : 0 }}>
            <Title
              level={isMobile ? 3 : 2}
              style={{
                margin: 0,
                color: "#2d3436",
                fontFamily: "Kanit",
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              {location.pathname === "/"
                ? "Thư viện Từ vựng 📚"
                : "Phòng Hội thoại 💬"}
            </Title>
            <Text
              style={{
                color: "#888",
                fontFamily: "Kanit",
                fontSize: isMobile ? "13px" : "15px",
                display: "block",
                marginTop: 4,
              }}
            >
              {location.pathname === "/"
                ? "Khám phá từ mới và luyện nghe"
                : "Luyện tập các tình huống thực tế"}
            </Text>
          </div>
        </Header>
        <Content style={{ margin: isMobile ? "0 16px 24px" : "0 40px 40px" }}>
          <div
            style={{
              padding: isMobile ? 16 : 32,
              minHeight: 400,
              background: "#fff",
              borderRadius: isMobile ? 16 : 30,
              boxShadow: "0 20px 40px rgba(200, 200, 200, 0.15)",
              overflow: "hidden",
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>

      {/* 2. Thêm nút Back to Top */}
      <FloatButton.BackTop
        type="primary"
        style={{ right: 24, bottom: 24 }}
        visibilityHeight={200}
      />
    </Layout>
  );
};

export default MainLayout;
